export default __webpack_public_path__ + "static/media/confirmationMail.9a22f4bb.svg";